/**
 * Module dependencies.
 */

import { ReactPlayerProps } from 'react-player';
import React, { ReactElement, useRef } from 'react';
import dynamic from 'next/dynamic';
import styled from 'styled-components';

/**
 * `ReactPlayer`.
 */

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

/**
 * Export `VideoPlayerProps` interface.
 */

export interface VideoPlayerProps extends ReactPlayerProps {
  className?: string;
  image?: string;
  style?: any;
}

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;

/**
 * `StyledReactPlayer` styled component.
 */

const StyledReactPlayer = styled(ReactPlayer)`
  left: 0;
  position: absolute;
  top: 0;

  video {
    object-fit: cover;
  }
`;

/**
 * Export `VideoPlayer` component.
 */

export const VideoPlayer = (props: VideoPlayerProps): ReactElement => {
  const { className, ...rest } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <Wrapper className={className} ref={wrapperRef}>
      <StyledReactPlayer {...rest} height={'100%'} width={'100%'} />
    </Wrapper>
  );
};

/**
 * Export `VideoPlayer` component.
 */

export default VideoPlayer;
